<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<p class="trans"><a href="#/html/03_contents#trans"><b>TRANSLATOR’S NOTE:</b></a></p>
<p class="smallspace">
</p><p class="ind">At times I have given an English equivalent to some of the French expressions, while on other occasions I exclusively used the French term (example: <i>ramener, rassembler.</i>)</p>
<p class="smallspace">
</p><p class="trans_noind"><i>La Mise en main</i> - in hand; bringing the horse in the hand; yielding of the jaw in the position of the <i>ramener,</i> on the bit.</p>
<p class="smallspace">
</p><p class="trans_noind"><i>Le Ramener</i> - flexing of the poll, with the forehead vertical; entails a degree of collection.</p>
<p class="smallspace">
</p><p class="trans_noind"><i>La Descente de main</i> - yielding of the hand, finger and/or rein pressure the horse must not change his pace or position; he is in self-carriage.</p>
<p class="smallspace">
</p><p class="trans_noind"><i>La Descente de jambes</i> - yielding of legs; ceasing the action of legs.</p>
<p class="smallspace">
</p><p class="trans_noind"><i>L’effet d’ensemble</i> - Combined or coordinated effect; use of the leg and/or spur simultaneously combined with the use of the hand.</p>
<p class="smallspace">
</p><p class="trans_noind"><i>Rassembler, rassemblé</i> - I have used the French term <i>rassembler</i> exclusively because the English term <i>collection</i> is not quite as accurate, with a more limiting meaning. <i>Rassembler</i> describes the bearing of the horse’s head in the position of the <i>ramener</i> and the hindquarters engaged in collection. When using the term <i>rassembler,</i> while <i>collection</i> is involved, it includes each and every part and action of the horse, the suppleness of his body, his back, legs, the pliancy of his <i>ressorts</i> (that is, “springs,” his joints and muscles, etc.) his ease, harmony, and generosity when moving, the cadence and rhythm of his gaits, and, above all, his lightness. <i>Rassembler</i> implies the collection, the gathering together of the entire horse, the convergence of the horse’s forehand and his hindquarters. It is the all-round perfection of a well schooled horse, which, together with lightness, is the crowning glory of a trainer’s efforts.</p>
<p class="smallspace">
</p><p class="trans_noind"><i>Dressage -</i> Used only to indicate the discipline (schooling of horses and competitive dressage); the English term “schooling” has been used when the actual training of horses is involved.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_translate.vue?117b7b52